import React, { useEffect, useState } from 'react';
import * as S from './styles';
import HPLogo from 'src/assets/images/HP-logo-blue.svg';
import { Header } from '@veneer/core';
import { useDependencyManagerContext } from 'src/contexts/dependencyManager';
import { decodeBase64ToObject } from 'src/utils/base64';
import { createAnalyticEvent } from 'src/helpers/createAnalyticEvent';

const TinyTracker = () => {
  const query = new URLSearchParams(window.location.search);
  const { northboundAPIs } = useDependencyManagerContext();
  const [acceptedAnalytics, setAcceptedAnalytics] = useState(false);

  function capitalizeFirstLetter(str: string): string {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  function sendFeedbackEvent(params: Record<string, string>) {
    if (params['originator'] && params['feedback']) {
      northboundAPIs.v1.analytics.publishCdmEvents(
        [
          createAnalyticEvent({
            action: 'ScreenDisplayed',
            activity: params['originator'],
            screenName: 'Feedback',
            screenPath: '/ReactTinyTracker/',
            screenMode: capitalizeFirstLetter(params['feedback']),
            version: '1.5.0'
          })
        ],
        params['workflowId']
          ? {
              metadata: {
                xCorrelationId: params['workflowId']
              }
            }
          : undefined
      );
    }
  }

  useEffect(() => {
    if (acceptedAnalytics && northboundAPIs?.v1.analytics?.publishCdmEvents) {
      const stateQueryString = query.get('state');

      if (stateQueryString) {
        const params = decodeBase64ToObject(stateQueryString);
        sendFeedbackEvent(params);
      }
    }
  }, [acceptedAnalytics]);

  useEffect(() => {
    const ANALYTICS_OPT_IN_GROUP = '2:1'; // User accepted the "Performance and Analytics" consent
    const { _O: OptInApi } = window;
    if (OptInApi) {
      OptInApi.onOptInGroups(() => {
        setAcceptedAnalytics(true);
      }, ANALYTICS_OPT_IN_GROUP);
    } else {
      if (!window.dataLayer) {
        window.dataLayer = [];
      }

      window.dataLayer.push({
        event: 'pb.onOptInGroups',
        groups: ANALYTICS_OPT_IN_GROUP,
        callback: () => {
          setAcceptedAnalytics(true);
        }
      });
    }
  }, []);

  return (
    <>
      <Header
        position="fixed"
        leadingArea={<S.Img src={HPLogo} />}
        customStyle={{ boxShadow: '0px 8px 16px -8px #00000014' }}
      />
      <S.Container>
        <S.FeedbackText>Your feedback has been submitted!</S.FeedbackText>
      </S.Container>
      <S.CustomFooter
        mainContent={{
          leadingArea: (
            <S.CopyrightText>
              Copyright {new Date().getFullYear()} HP Inc. All rights reserved.
            </S.CopyrightText>
          )
        }}
      />
    </>
  );
};

export default TinyTracker;
